import { yupResolver } from '@hookform/resolvers/yup';
import Box from '@mui/material/Box';
import { forwardRef, useImperativeHandle } from 'react';
import { useForm } from 'react-hook-form';

import TextInput from '~components/FormFields/v2/TextInput';
import { Account } from '~hooks/useAccount/models';

import { NotesDto, notesSchema, setNotesSchemaDefaultValues } from './notesSchema';

export type NotesPanelHandler = {
  onSubmit: () => Promise<NotesDto | undefined>;
};

interface NotesPanelProps {
  account?: Account;
}

const NotesPanel = forwardRef<NotesPanelHandler, NotesPanelProps>(function NotesPanel(
  { account },
  ref,
) {
  const { control, handleSubmit } = useForm<NotesDto>({
    resolver: yupResolver(notesSchema),
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    defaultValues: setNotesSchemaDefaultValues(account),
  });

  useImperativeHandle(
    ref,
    () => ({
      onSubmit() {
        return new Promise((resolve) => {
          handleSubmit(
            (data) => {
              resolve(data);
            },
            () => {
              resolve(undefined);
            },
          )();
        });
      },
    }),
    [handleSubmit],
  );

  return (
    <Box sx={{ width: '100%' }}>
      <TextInput
        control={control}
        slotProps={{ htmlInput: { maxLength: 350 } }}
        name="notes"
        rows={2}
      />
    </Box>
  );
});

export default NotesPanel;
